/**
 * Central mock asset URLs. Swap these for real club photography without
 * touching individual components. Uses Unsplash source photos scoped to
 * football/stadium/training imagery. Rendered on top of dark navy overlays
 * for text legibility.
 */
const U = "https://images.unsplash.com/";
const IMG = (id: string, w = 1600) => `${U}${id}?auto=format&fit=crop&w=${w}&q=75`;

export const mockAssets = {
  hero: [
    IMG("photo-1508098682722-e99c43a406b2"), // stadium lights
    IMG("photo-1517927033932-b3d18e61fb3a"), // stadium wide
    IMG("photo-1521412644187-c49fa049e84d"), // player action
    IMG("photo-1550831107-1553da8c8464"), // celebration
  ],
  action: [
    IMG("photo-1518091043644-c1d4457512c6"),
    IMG("photo-1560272564-c83b66b1ad12"),
    IMG("photo-1517466787929-bc90951d0974"),
    IMG("photo-1544620347-c4fd4a3d5957"),
    IMG("photo-1543326727-cf6c39e8f84c"),
    IMG("photo-1508098682722-e99c43a406b2"),
    IMG("photo-1522778034537-20a2486be803"),
    IMG("photo-1526232761682-d26e03ac148e"),
  ],
  stadium: [
    IMG("photo-1459865264687-595d652de67e"),
    IMG("photo-1522778119026-d647f0596c20"),
    IMG("photo-1508098682722-e99c43a406b2"),
  ],
  training: [
    IMG("photo-1526676037777-05a232554f77"),
    IMG("photo-1526232684083-c69eba1a75f4"),
    IMG("photo-1517649763962-0c623066013b"),
    IMG("photo-1508344928-3f8fa8db5a17"),
  ],
  fans: [
    IMG("photo-1522778034537-20a2486be803"),
    IMG("photo-1543351611-58f69d7c1781"),
    IMG("photo-1560272564-c83b66b1ad12"),
  ],
  community: [IMG("photo-1526676037777-05a232554f77"), IMG("photo-1519058082700-08a0b56da9b4")],
  portrait: (i: number) => {
    // Portrait-oriented athlete stock photography (deterministic per index)
    const ids = [
      "photo-1583500178690-f7fd39a19cff",
      "photo-1618886614638-80e3c103d31a",
      "photo-1607627000458-210e8d2bdb1d",
      "photo-1552674605-db6ffd4facb5",
      "photo-1571019613454-1cb2f99b2d8b",
      "photo-1524863479829-916d8e77f114",
      "photo-1595152772835-219674b2a8a6",
      "photo-1546519638-68e109498ffc",
      "photo-1517466787929-bc90951d0974",
      "photo-1519058082700-08a0b56da9b4",
    ];
    return `${U}${ids[i % ids.length]}?auto=format&fit=crop&w=800&h=1000&q=75`;
  },
  staffPortrait: (i: number) => {
    const ids = [
      "photo-1560250097-0b93528c311a",
      "photo-1573496359142-b8d87734a5a2",
      "photo-1519085360753-af0119f7cbe7",
      "photo-1573497019940-1c28c88b4f3e",
      "photo-1580489944761-15a19d654956",
      "photo-1519345182560-3f2917c472ef",
      "photo-1531123897727-8f129e1688ce",
      "photo-1544005313-94ddf0286df2",
    ];
    return `${U}${ids[i % ids.length]}?auto=format&fit=crop&w=800&h=1000&q=75`;
  },
  gallery: (i: number) => {
    const ids = [
      "photo-1508098682722-e99c43a406b2",
      "photo-1518091043644-c1d4457512c6",
      "photo-1560272564-c83b66b1ad12",
      "photo-1517466787929-bc90951d0974",
      "photo-1544620347-c4fd4a3d5957",
      "photo-1543326727-cf6c39e8f84c",
      "photo-1522778034537-20a2486be803",
      "photo-1526232761682-d26e03ac148e",
      "photo-1459865264687-595d652de67e",
      "photo-1522778119026-d647f0596c20",
      "photo-1526676037777-05a232554f77",
      "photo-1526232684083-c69eba1a75f4",
      "photo-1517649763962-0c623066013b",
      "photo-1508344928-3f8fa8db5a17",
      "photo-1543351611-58f69d7c1781",
    ];
    return `${U}${ids[i % ids.length]}?auto=format&fit=crop&w=1200&q=75`;
  },
  sponsor: (name: string) =>
    `data:image/svg+xml;utf8,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 80"><rect width="220" height="80" fill="none"/><text x="50%" y="52%" font-family="Inter, sans-serif" font-size="22" font-weight="800" fill="#E5E8ED" text-anchor="middle" letter-spacing="2">${name.toUpperCase()}</text></svg>`,
    )}`,
};
